import { api } from './api';
import { ChatbotStudent } from './studentData';

export interface ProjectData {
  id: string;
  name: string;
  collaboratorIds: string[];
  collaborators?: ChatbotStudent[];
  isShown?: boolean;
  isGroupProject?: boolean;
  type?: string;
  schoolId?: string;
  schoolName?: string;
  createdAt?: string;
  updatedAt?: string;
  attributes?: any;
  answersId?: string;
  templateId?: string;
}

export class GroupProject {
  token = '';
  constructor(token: string) {
    this.token = token;
  }

  setToken(token: string) {
    this.token = token;
  }

  async createGroupProject(props: {
    name: string;
    collaboratorIds: string[];
    templateId: string;
    schoolId?: string;
    schoolName?: string;
  }) {
    const { name, collaboratorIds, templateId, schoolId, schoolName } = props;
    return api<any>(
      '/projects',
      {
        body: {
          name,
          templateId,
          collaborators: collaboratorIds,
          schoolId,
          schoolName,
          type: 'RASA',
        },
        method: 'POST',
      },
      this.token,
    );
  }

  async updateGroupProject(projectData: ProjectData) {
    return api<any>(
      `/projects/${projectData.id}`,
      {
        body: {
          collaborators: projectData.collaboratorIds,
          name: projectData.name,
          ...(projectData.attributes.answers_id
            ? { answersId: projectData.attributes.answers_id }
            : {}),
          type: projectData.type,
        },
        method: 'PATCH',
      },
      this.token,
    );
  }

  async updateAnswersId(id: string, answersId: string | null) {
    return api<any>(
      `/projects/${id}`,
      { body: { answersId }, method: 'PATCH' },
      this.token,
    );
  }

  async updateIsShown(id: string, isShown: boolean) {
    return api<any>(
      `/projects/${id}/show`,
      { body: { isShown }, method: 'PATCH' },
      this.token,
    );
  }

  async deleteGroupProject(projectId: string) {
    return api<any>(
      `/projects/${projectId}`,
      { method: 'DELETE', body: {} },
      this.token,
    );
  }
}

export default new GroupProject('');
